/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
window.PXUTheme.jsCollection = {
  init: function($section) {

    // Add settings from schema to current object
    window.PXUTheme.jsCollection = $.extend(this, window.PXUTheme.getSectionData($section));
    this.bindHistory();

    // function to check if browser is IE
    var isIE11 = !!navigator.userAgent.match(/Trident.*rv\:11\./);

    // Load 3D libraries only for models already rendered on this page.
    // Quick shop loads its own media libraries when its Product is created.
    if (!isIE11 && document.querySelector('model-viewer, [data-shopify-model3d-id]')) {
      window.Shopify.loadFeatures([
        {
          name: 'shopify-xr',
          version: '1.0',
        },
        {
          name: 'model-viewer-ui',
          version: '1.0',
        }
      ],)
    }

    if (this.enable_sorting == true) {
      $('#sort-by').val($('#sort-by').data('default-sort'));
    }

    if (this.enable_filter == true || this.enable_sorting == true) {
      $('#tag_filter, #sort-by').off('change.alpCollection').on('change.alpCollection', function() {
        window.PXUTheme.jsCollection.filterURL();
      });
    }

    if ($('[data-option-filter]').length) {
      // Show enabled filter tags based on selected checkboxes
      $('[data-tag-filter-checkbox]:checked').each(function(){
        window.PXUTheme.jsCollection.multiTagFilter.showSelectedFilter($(this));
      })
    }

    // If breadcrumbs enabled and basic pagination is set, call breadcrumbs object
    if (this.enable_breadcrumb && this.pagination_type == 'basic_pagination') {
      window.PXUTheme.breadcrumbs.init(this.number_of_pages);
    }

    /* Collection sidebar filter */
    $('body').off('click.alpCollection', '[data-option-filter]').on('click.alpCollection', '[data-option-filter]', function(e) {
      e.preventDefault();

      $(this).find('input').prop('checked', true);

      window.PXUTheme.jsCollection.multiTagFilter.init($(this));
      window.PXUTheme.scrollToTop($('.collection__content'));
    });

    $('body').off('click.alpCollection', '[data-clear-filter]').on('click.alpCollection', '[data-clear-filter]', function () {
      const $el = $(this).siblings('[data-option-filter]');
      const $productTagFilter = $('#tag_filter');

      $productTagFilter.find('option:eq(0)').prop('selected', true);
      window.PXUTheme.jsCollection.multiTagFilter.clearSelectedFilter($el);
      window.PXUTheme.scrollToTop($('.collection__content'));

    });
  },
  filterURL: function() {

    var selectedOptions = [],
        currentTags = '',
        currentURL = new URL(window.location.href);

    // check if language has been translated. Length equals one when default language (eg: '/') and greater than 1 when language is translated (eg: '/fr')
    if (window.PXUTheme.routes.root_url.length > 1) {
      var url1 = $.url('1') ? '/' + $.url('1') + '/' : '';
      var url2 = $.url('2') ? $.url('2') + '/' : '';
      var url3 = $.url('3') ? $.url('3') + '/' : '';
      var path = url1 + url2 + url3;
    } else {
      var url1 = $.url('1') ? '/' + $.url('1') + '/' : '';
      var url2 = $.url('2') ? $.url('2') + '/' : '';
      var path = url1 + url2;
    }

    //Handle dropdowns if they exist
    if ($('#sort-by').length){
      var sort = $('#sort-by').val();
      if (sort) currentURL.searchParams.set('sort_by', sort);
    }

    if ($('#tag_filter').length){

      if ($('#tag_filter').data('default-collection') != $('#tag_filter').val()){
        var urlTag = $('#tag_filter').val().substr($('#tag_filter').val().lastIndexOf('/') + 1);

        if (urlTag != 'all'){
          if ($.inArray( urlTag, selectedOptions ) > -1){
            //Do nothing
          } else {
            selectedOptions.unshift(urlTag);
          }
        }
      }
    }

    //Add all checkbox values to array
    $('[data-option-filter] input:checked').each(function () {
      selectedOptions.push($(this).val());
    });

    selectedOptions = $.makeArray(selectedOptions);

    //Loop through tags to create string to update page url
    $.each(selectedOptions, function(i, value){

      if (i != selectedOptions.length - 1) {
        currentTags += selectedOptions[i] + '+';
      } else {
        currentTags += selectedOptions[i];
      }

    });

    // Read the live URL, retaining repeated facets and attribution after Back.
    this.processUrl(path, currentTags, currentURL.search + currentURL.hash);
  },
  processUrl: function (path, tags, query) {

    var target = new URL(path + tags + (query || ''), window.location.href);
    target.searchParams.delete('page');
    if (!target.hash) target.hash = window.location.hash;
    this.updateView(target.pathname + target.search + target.hash);
  },
  bindHistory: function() {
    var collection = this;
    if (this._historyHandler) return;
    this._renderedURL = window.location.pathname + window.location.search + window.location.hash;
    this._historyHandler = function() {
      if (!$('[data-collection-main]').length) return;
      var current = window.location.pathname + window.location.search + window.location.hash;
      if (collection._renderedURL && collection._renderedURL.split('#')[0] === current.split('#')[0]) return;
      collection.updateView(current, { history: false });
    };
    this._pageShowHandler = function(event) {
      if (!event.persisted) return;
      // A BFCache page already contains its products. Only reconcile a URL
      // changed by history; never reload a restored page or duplicate entries.
      collection.cancelRequest();
      collection.setLoading(false);
      collection._historyHandler();
    };
    window.addEventListener('popstate', this._historyHandler);
    window.addEventListener('pageshow', this._pageShowHandler);
  },
  cancelRequest: function() {
    this._requestVersion = (this._requestVersion || 0) + 1;
    var request = this._request;
    this._request = null;
    if (request && request.abort) request.abort();
  },
  setLoading: function(loading) {
    $('[data-collection-main]').attr('aria-busy', loading ? 'true' : 'false');
    var $matrix = $('.collection-matrix');
    var $loader = $('.collection-matrix__wrapper .collection__loading-icon');
    $matrix.removeClass('fadeOut fadeIn animated loading-in-progress');
    if (loading) {
      // Keep existing products visible while a replacement is being fetched.
      $matrix.addClass('loading-in-progress');
      $loader.stop(true, true).fadeIn();
    } else {
      $loader.stop(true, true).hide();
    }
  },
  showFilterError: function(filterURL) {
    $('[data-collection-filter-error]').remove();
    var $message = $('<p>')
      .attr('data-collection-filter-error', '')
      .attr('role', 'alert')
      .addClass('collection-filter-error')
      .text('No pudimos actualizar los filtros. Tus productos siguen disponibles. ');
    $message.append($('<a>').attr('href', filterURL).text('Volver a intentar'));
    $('[data-collection-main]').prepend($message);
  },
  syncFilterControls: function($response) {
    ['#tag_filter', '#sort-by'].forEach(function(selector) {
      var $newControl = $response.find(selector);
      if ($newControl.length) $(selector).val($newControl.val());
    });
    // Sidebar inputs live outside the replaced grid. Restore them too on Back.
    var selected = [];
    $response.find('[data-tag-filter-checkbox]:checked').each(function() {
      selected.push($(this).val());
    });
    $('.tag-filter__item').removeClass('is-active is-hidden');
    $('[data-clear-filter]').addClass('is-hidden');
    $('[data-tag-filter-checkbox]').each(function() {
      var $input = $(this);
      var checked = selected.indexOf($input.val()) !== -1;
      $input.prop('checked', checked);
      if (checked) window.PXUTheme.jsCollection.multiTagFilter.showSelectedFilter($input);
    });
  },
  updateView: function(filterURL, options) {
    var collection = this;
    var target = new URL(filterURL, window.location.href);
    if (target.origin !== window.location.origin) return;
    var viewURL = target.pathname + target.search + target.hash;
    options = options || {};
    this.cancelRequest();
    var version = this._requestVersion;
    $('[data-collection-filter-error]').remove();
    this._request = $.ajax({
      type: 'GET',
      url: viewURL,
      timeout: 15000,
      beforeSend: function() {
        collection.setLoading(true);
      },
      success: function(data) {
        if (version !== collection._requestVersion) return;
        var $response = $(data);
        var $newMain = $response.find('[data-collection-main]');
        if (!$newMain.length) {
          collection.showFilterError(viewURL);
          return;
        }

        var $newBreadcrumb = $response.find('.breadcrumb__container');
        if ($newBreadcrumb.length) $('.breadcrumb__container').html($newBreadcrumb.html());
        $('[data-collection-main]').html($newMain.html());
        collection.syncFilterControls($response);

        collection._renderedURL = viewURL;
        var current = window.location.pathname + window.location.search + window.location.hash;
        if (options.history !== false && viewURL !== current && window.history && window.history.pushState) {
          window.history.pushState({ alpNativeCollection: true }, '', viewURL);
        }

        if ($('[data-custom-pagination]').length) {
          window.PXUTheme.infiniteScroll.init();
        }
        if (window.PXUTheme.productReviews && window.PXUTheme.productReviews.init) {
          window.PXUTheme.productReviews.init();
        }
      },
      error: function(request, status) {
        if (version !== collection._requestVersion || status === 'abort') return;
        collection.showFilterError(viewURL);
      },
      complete: function() {
        if (version !== collection._requestVersion) return;
        collection._request = null;
        collection.setLoading(false);
      },
      dataType: 'html'
    });
  },
  multiTagFilter: {
    init: function ($el) {

      // Show filter and hide siblings
      this.showSelectedFilter($el);

      // Update url
      window.PXUTheme.jsCollection.filterURL();

      var urlIndex;
      if (window.PXUTheme.routes.root_url.length > 1) {
        urlIndex = 3
      } else {
        urlIndex = 2
      }

      // Hide filters if types or vendors is in URL (can't be combined)
      if ($.url(urlIndex) === 'types' || $.url(urlIndex) === 'vendors') {
        $('.block__tag-filter').remove();
      }

    },
    showSelectedFilter: function ($el) {
      const $sidebarToggleBlock = $el.parents('.sidebar-toggle-active');
      const $filterItem = $el.parents('.tag-filter__item');

      $filterItem.addClass('is-active');
      $filterItem.siblings(':not(.is-active)').addClass('is-hidden');
      $filterItem.find('[data-clear-filter]').removeClass('is-hidden');

      // If sidebar toggle is enabled, show filter in sidebar content
      if ($sidebarToggleBlock.length) {
        let $toggleBtn = $sidebarToggleBlock.find('[data-sidebar-block__toggle="closed"]');

        window.PXUTheme.jsSidebar.openSidebarBlock($toggleBtn);
      }

    },
    clearSelectedFilter: function ($el) {

      const $filterItem = $el.parents('.tag-filter__item');

      $filterItem.removeClass('is-active')
            .find('input').prop("checked", false);
      $filterItem.siblings()
            .removeClass('is-hidden');
      $filterItem.find('[data-clear-filter]')
            .addClass('is-hidden');

      //Update url
      window.PXUTheme.jsCollection.filterURL();
    }
  },
  unload: function($section) {
    this.cancelRequest();
    this.setLoading(false);
    $('#tag_filter, #sort-by').off('.alpCollection');
    $('body').off('.alpCollection');
    window.removeEventListener('popstate', this._historyHandler);
    window.removeEventListener('pageshow', this._pageShowHandler);
    this._historyHandler = null;
    this._pageShowHandler = null;
    window.PXUTheme.breadcrumbs.unload();
  }
}

/******/ })()
;

